// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2DVfDHkj-yxI7J {\n  padding: 8px 4px;\n  align-self: center;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n._2DVfDHkj-yxI7J ._1nqF8b5c_yQ2lM {\n  flex: 0 0 auto;\n  margin: 2px 0 0;\n  padding: 0;\n  align-items: start;\n}\n._2DVfDHkj-yxI7J ._1nqF8b5c_yQ2lM input {\n  cursor: pointer;\n}\n.WIiHD_qsJ0mAjy {\n  flex: 0 0 auto;\n  margin: 0 3px;\n  align-self: flex-start;\n}\n._1XNZ3WA851NXY1 {\n  display: none;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dueCell": "_2DVfDHkj-yxI7J",
	"checkBox": "_1nqF8b5c_yQ2lM",
	"dueDateBadge": "WIiHD_qsJ0mAjy",
	"hiddenLabel": "_1XNZ3WA851NXY1"
};
export default ___CSS_LOADER_EXPORT___;
